export default {"src":"/_next/static/media/fiona-logo.inline.70938a60.svg","height":29,"width":94,"blurWidth":0,"blurHeight":0};